export default {
  "languageDisplayName": "Srpski",
  "greeting": "Zdravo",
  "Profile": "Profil",
  "Interests": "Interese",
  "Recurring Payments": "Periodične Uplate",
  "Payment Methods": "Načini plaćanja",
  "Transactions": "Transakcije",
  "Passport": "Pasoš",
  "Wallet": "Novčanik",
  "Subscriptions": "Pretplate",
  "Projects": "Projekata",
  "Campaigns": "Kampanje",
  "Volunteer": "Volonter",
  "Events": "Događaji",
  "Settings": "Podešavanja",
  "My": "Moje",
  "Groups": "Grupe",
  "Awards": "Nagrade",
  "Change": "Promenji",
  "Image": "Slika",
  "You have no": "Nemate",
  "Now": "Sada",
  "Booths": "Kutije",
  "You don't have any listed": "Nemate nikakvih",
  "Add": "Dodaj",
  "You Might Like:": "Možda će ti se svideti: ",
  "Start Date": "Datum Početka",
  "End Date": "Krajnji Datum",
  "Payment Method": "Način plaćanja",
  "Filter": "Filter",
  "Download": "Preuzmite",
  "Saved Cards": "Sačuvane Kartice",
  "Saved Debits": "Sačuvane Zaduženja",
  "Recommended": "Preporučeno",
  "Subscribe": "Pretplatiti se",
  "Unsubscribe": "Odjavite se",
  "Click to": "Kliknite za",
  "Update": "Ažurirati",
  "Register": "Prijavi se",
  "Unregister": "Otkaži",
  "Add More Interests": "Dodajte Više Interesa",
  "Add More Skills": "Dodajte Više Veština",
  "Search": "Pretraži",
  "Close": "Zatvori",
  "Credit Card": "Kreditna Kartica",
  "card": "Kreditna Kartica",
  "Debit": "Dugovanje",
  "debit": "Dugovanje",
  "Cancel": "Otkaži",
  "Account Name": "Ime Naloga",
  "Institution Name": "Ime institucije",
  "BSB Number": "Australijski BSB Broj",
  "Account Number": "Broj Računa",
  "Cardholder Name": "Ime Vlasnika Kartice",
  "Card Number": "Broj Kartice",
  "Expiration Date": "Isteka Kreditne",
  "Cannot Be Empty": "Ispuni",
  "Not Valid": "Ne Važi",
  "Save": "Sačuvaj",
  "Cannot Be Empty or Contain Numbers": "Ne Može Biti Prazno Ili Sadržavati Brojeve",
  "Login": "Prijavite se",
  "Awaiting Login": "čekajući Prijavljivanje",
  "Awaiting Registration": "čekamo registraciju",
  "Please": "Molimo vas",
  "Logout": "Odjaviti se",
  "Offline": "Nema Konekcije",
  "No Popups": "Primjetili smo da ste blokirali pojavne okomite, molimo vas provjerite da li ste ih omogućili za ovu stranicu.",
  "Voting": "Glasanje",
  "Site Settings": "Podešavanja Veb Stranice",
  "My Settings": "Moje Postavke",
  "Security Settings": "Bezbednosne Postavke",
  "2-Factor Authentickation": "2-Faktor Autentikacije",
  "Language": "Jezik",
  "Name": "Ime",
  "Addresses": "Adrese",
  "Work": "Posao",
  "Home": "Kuća",
  "Other": "Drugo",
  "Phone Numbers": "Brojevi Telefona",
  "Email Addresses": "Imejl Adrese",
  "First Name": "Ime",
  "Last Name": "Prezime",
  "Address Type": "Tip A drese",
  "Street Address 1": "Ulica i Broj",
  "Street Address 2": "Adresa Linija 2",
  "City": "Grad",
  "State": "Država",
  "Postcode": "Poštanski Broj",
  "Country": "Zemlja",
  "Phone Number Type": "Tip Telefona",
  "Email Type": "Tip Imejl Adrese",
  "Custom Type": "Prilagođeni Tip",
  "Number": "Broj",
  "Email": "Imejl",
  "Emails": "E-poruke",
  "Phone": "Telefon",
  "Phones": "Telefoni",
  "Address": "Adresa",
  "Add Address": "Dodaj Adresu",
  "Add Phone": "Dodaj Telefon",
  "Add Email": "Dodaj E-poštu",
  "Accommodation": "Smeštaj",
  "Mobile": "Mobilni",
  "View": "Pogledaj",
  "No Groups": "Nemate Grupe",
  "Recommended Groups": "Preporučne Grupe",
  "Roles": "Uloge",
  "Admin": "Admin",
  "Photos": "Slike",
  "Join": "Priključi se",
  "Leave": "Napusti",
  "Joined": "Već se priključio",
  "Member": "Član",
  "Members": "Članovi",
  "Are you sure?": "Da Li Ste Sigurni?",
  "Yes": "Da",
  "No": "Ne",
  "Fitness": "Fitnes",
  "Help": "Pomoć",
  "Gallery": "Galerija",
  "Support": "Podržite",
  "Unsupport": "Otkaži Podršku",
  "Skills": "Većeštine",
  "Communities": "Zajednice",
  "Click here to enter": "Kliknite ovde da biste ušli",
  "Rooms": "Sobe",
  "Boards": "Tabla",
  "Cloud": "Oblak",
  "Future": "Budućnost",
  "Churches": "Crkve",
  "Password": "Sifra",
  "password": "sifra",
  "New Password": "Nova Šifra",
  "Old Password": "Stara Šifra",
  "Confirm Password": "Potvrdi Šifru",
  "Subscribers": "Pretplatnici",
  "Browse": "Pretražite",
  "Past Events": "Prošli Događaji",
  "Future Events": "Budući Događaji",
  "Create": "Kreiraj",
  "Edit": "Promeni",
  "Issues": "Problemi",
  "Organizer": "Organizator",
  "Next": "Sledeći",
  "Back": "Nazad",
  "Confirm": "Potvrdi",
  "Select Payment Method": "Izaberite Način Plaćanja",
  "Please provide a payment method": "Unesite Način Plaćanja",
  "Select A Support Level": "Izaberite Nivo Podrške",
  "Your support will be sent from your selected payment method:": "Vaša podrška će biti poslata sa odabranog načina plaćanja:",
  "My Gallery": "Moja Galerija",
  "Local Artists": "Lokalni Umetnici",
  "My Fitness": "Moje Zdravlje",
  "Next Due": "Nekt Due",
  "Frequency": "Frekvencija",
  "Status": "Status",
  "Link Your Fitbit": "Povežite Fitbit",
  "Link Your Strava": "Povežite Strava",
  "Active": "Aktivno",
  "Cancelled": "Otkazano",
  "Tracker": "Traker",
  "Mobile Number": "Broj Mobilnog Telefona",
  "Day": "Dan",
  "Month": "Mesec",
  "Year": "Godine",
  "Date Of Birth": "Datum Rođenja",
  "Sign Up": "Prijavi se",
  "Check In": "Prijaviti",
  "News": "Vesti",
  "Deregister": "Poništi registraciju",
  "What's On": "Šta je na",
  "On Now": "Dešava se sada",
  "Coming Up": "Dešava se kasnije",
  "There are currently no upcoming events": "Trenutno nema predstojećih događaja",
  "Next Up": "Sledeći",
  "Near Me": "Blizu mene",
  "Goals": "Golovi",
  "Connect": "Poveži se",
  "Select An Option": "Izaberite Opciju",
  "Mentors": "Mentori",
  "Employment": "Radni Odnos",
  "Log In": "Prijavite Se",
  "Log Out": "Odjavite Se",
  "Please log in or sign up to continue.": "Prijavite se ili registrujte da biste nastavili.",
  "Add your group": "Dodajte svoju grupu",
  "Preferred": "Poželjno",
  "Read More": "Opširnije",
  "Description": "Opis",
  "Submit": "Prihvati",
  "Subject": "Predmet",
  "Message": "Poruka",
  "Send Me A Copy": "Pošaljite Mi Kopiju",
  "Contacts": "Kontakti",
  "Followers": "Pratite",
  "Follow": "Prati",
  "Following": "Sledeći",
  "Contact Number": "Kontakt Broj",
  "Any unsaved information may be lost": "Sve Nesačuvane Informacije Mogu De Izgubiti",
  "Add Location": "Dodaj lokaciju",
  "Edit Location": "Izmeni lokaciju",
  "Last Logged In": "Poslednja prijava",
  "Your Connections": "Vaše veze",
  "There are no connections currently linked to your account": "Trenutno nema veza povezanih sa vašim nalogom",
  "Connection Type": "Vrsta konekcije",
  "Remove Connection": "Uklonite vezu",
  "Connect To: ": "Poveži sa: ",
  "Timezone": "Vremenska zona",
  "forgotPassword": "Ne znam svoju lozinku",
  "createNewAccount": "Napravite novi nalog",
  "logInWith": "Prijavite se sa",
  "orEnterYour": "ili koristite svoje",
  "usernameOrEmail": "korisničko ime ili adresu e-pošte",
  "passwordRequired": "potrebna je šifra",
  "enterPasswordFor": "otkucajte lozinku za",
  "authenticationFailed": "autentifikacija nije uspela",
  "signIn": "prijavite se",
  "iHaveAnAccount": "imam nalog",
  "termsAndPrivacy": "uslove i privatnost",
  "securedBy": "obezbeđeno preko",
  "Delete": "Izbriši",
  "Please Wait": "Sačekajte",
  "loadingDiscussions": "Učitavamo vaše diskusije za ćaskanje!",
  "No Discussions": "Bez diskusija!",
  "joinDiscussion": "Pridružite se diskusiji da bi se to prikazalo ovde!",
  "Discussion": "Diskusija",
  "Log in with :": "Prijavite se sa:",
  "Powered By:": "Povered Bi:",
  "Please accept the latest": "Prihvatite najnovije",
  "Terms": "Uslove",
  "Privacy Policy": "Pravila o Privatnosti",
  "terms": "uslove",
  "privacy policy": "pravila o privatnosti",
  "willRecieveFollowingInfo": "dobiće sledeće informacije:",
  "Email Address": "Adresa E-pošte",
  "and": "i",
  "We Use Cookies": "Koristimo kolačiće",
  "Cookies help us handle many processes our platform requires, please accept or review our available settings": "Kolačići nam pomažu da upravljamo mnogim procesima koje naša platforma zahteva, prihvatite ili pregledajte naša dostupna podešavanja",
  "ACCEPT ALL": "PRIHVATI SVE",
  "REJECT ALL": "ODBACI SVE",
  "ACCEPT CURRENT SELECTION": "PRIHVATI TRENUTNI IZBOR",
  "SETTINGS": "SETTINGS",
  "Manage cookie preferences": "Upravljajte podešavanjima kolačića",
  "Close modal": "Zatvori modal",
  "Strictly Necessary cookies": "Strogo neophodni kolačići",
  "These cookies are essential for the proper functioning of the website and cannot be disabled.": "Ovi kolačići su neophodni za pravilno funkcionisanje veb stranice i ne mogu se onemogućiti.",
  "Performance and Analytics": "Učinak i analitika",
  "These cookies collect information about how you use our website. All of the data is anonymized and cannot be used to identify you.": "Ovi kolačići prikupljaju informacije o tome kako koristite našu veb stranicu. Svi podaci su anonimni i ne mogu se koristiti za vašu identifikaciju.",
  "ACCEPT REQUIRED": "POTREBNO PRIHVATITI",
  "Terms and Privacy Policy Links": "Uslovi i linkovi politike privatnosti",
  "Services": "Usluge",
  "Profile Pages": "Profil Stranice",
  "Success": "Uspeh",
  "Your disconnection request has successfully been processed": "Vaš zahtev za prekid veze je uspešno obrađen",
  "Disconnecting will cause a new authorization prompt on next login to any related services": "Prekidanje veze će izazvati novi upit za autorizaciju prilikom sledećeg prijavljivanja na sve povezane usluge",
  "Legal": "Pravni",
  "Available Services": "Dostupne Usluge",
  "Link": "Link",
  "Disconnect": "Prekini",
  "Agreed": "Dogovoreno"
}